<template>
  <div :id="id" :style="{ height: height, width: width }"></div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
// let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null,
      defaultOptions: {}
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      let theme = this.option.config.theme
        ? this.option.config.theme
        : [
          '#0099FF',
          '#FF5A18',
          '#00B790',
          '#06C49C',
          '#FFB000',
          '#FA4300',
          '#FFFFFF',
          '#A352FF',
          '#3ED5FF',
          '#F07028'
        ]
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      const OPTIONS = this.option
      const seriesData = (OPTIONS.data || []).map((item, index) => {
        return Object.assign({
          type: 'line'
        }, item)
        // {
        //   data: item.data,
        //   name: item.name,
        //   type: 'line',
        //   lineStyle: {
        //     width: 3,
        //     type: index ? 'dashed' : 'solid'
        //   },
        //   smooth: true
        // }
      })
      this.chart.setOption({
        color: theme,
        title: {
          text: this.name,
          x: 'left',
          left: 0,
          top: 0,
          textStyle: {
            fontSize: 14,
            color: '#fff',
            lineHeight: 30
          }
        },
        legend: {
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 12,
          top: 10,
          right: 0,
          data: OPTIONS.config.legendData,
          textStyle: {
            fontSize: 12,
            color: '#F1F1F3'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: OPTIONS.config.xData,
            axisLine: {
              lineStyle: {
                color: '#999'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)'
              }
            },
            nameTextStyle: {
              color: '#999'
            },
            splitArea: {
              show: false
            },
            splitNumber: OPTIONS.config.splitNumber === undefined ? 5 : OPTIONS.config.splitNumber
          }
        ],
        series: seriesData
      })
    }
  },
  created () {}
}
</script>
